module.exports = __webpack_public_path__ + "img/dummy-image.9443b096.jpg";